document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    var open = document.body.classList.toggle('menu-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (event.target.closest('.site-nav a')) {
    document.body.classList.remove('menu-open');
  }
  if (event.target.closest('[data-search-open]')) {
    var searchOverlay = document.querySelector('[data-search-overlay]');
    if (searchOverlay) {
      searchOverlay.hidden = false;
      document.body.classList.add('search-open');
      event.target.closest('[data-search-open]').setAttribute('aria-expanded', 'true');
      window.setTimeout(function () { searchOverlay.querySelector('[data-search-input]')?.focus(); }, 30);
    }
  }
  if (event.target.closest('[data-search-close]') || event.target.matches('[data-search-overlay]')) closeSiteSearch();
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') closeSiteSearch();
  if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
    event.preventDefault();
    document.querySelector('[data-search-open]')?.click();
  }
});

function closeSiteSearch() {
  var searchOverlay = document.querySelector('[data-search-overlay]');
  if (!searchOverlay || searchOverlay.hidden) return;
  searchOverlay.hidden = true;
  document.body.classList.remove('search-open');
  document.querySelector('[data-search-open]')?.setAttribute('aria-expanded', 'false');
}

(function initStickyHeader() {
  var lastScrollY = window.scrollY;
  var ticking = false;

  function updateHeader() {
    var currentScrollY = window.scrollY;
    document.body.classList.toggle('header-scrolled', currentScrollY > 8);

    if (window.matchMedia('(max-width: 900px)').matches) {
      var movingDown = currentScrollY > lastScrollY + 7;
      var movingUp = currentScrollY < lastScrollY - 7;
      if (movingDown && currentScrollY > 110) document.body.classList.add('header-hidden');
      if (movingUp || currentScrollY < 40) document.body.classList.remove('header-hidden');
    } else {
      document.body.classList.remove('header-hidden');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateHeader);
  }, { passive: true });
  window.addEventListener('resize', updateHeader);
  updateHeader();
})();

document.addEventListener('change', function (event) {
  var form = event.target.closest('[data-facets-form]');
  if (!form) return;
  if (event.target.matches('[data-artist-filter]')) {
    applyCatalogueArtistFilter(document, event.target.value);
    var artistUrl = new URL(window.location.href);
    if (event.target.value) artistUrl.searchParams.set('artist', event.target.value);
    else artistUrl.searchParams.delete('artist');
    window.history.replaceState({}, '', artistUrl.toString());
    return;
  }
  if (event.target.name === 'sort_by') {
    var value = event.target.value;
    if (value.indexOf('artist-') === 0 || value.indexOf('title-') === 0 || value.indexOf('price-') === 0) {
      applyCatalogueSort(document, value);
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      window.history.replaceState({}, '', url.toString());
      return;
    }
  }
  form.submit();
});

document.addEventListener('DOMContentLoaded', function () {
  initCarousels(document);
  initExhibitionStatuses(document);
  initInquiryContext(document);
  initCatalogueDefaults(document);
  initProductGallery(document);
  initBookingWidgets(document);
});

function initProductGallery(scope) {
  var viewer = scope.querySelector('[data-product-viewer]');
  var lightbox = scope.querySelector('[data-product-lightbox]');
  if (!viewer || !lightbox || lightbox.dataset.galleryReady === 'true') return;

  lightbox.dataset.galleryReady = 'true';
  var slides = Array.from(lightbox.querySelectorAll('[data-gallery-slide]'));
  var currentLabel = lightbox.querySelector('[data-gallery-current]');
  var current = 0;

  function show(index) {
    current = (index + slides.length) % slides.length;
    slides.forEach(function (slide, slideIndex) { slide.hidden = slideIndex !== current; });
    if (currentLabel) currentLabel.textContent = String(current + 1);
  }

  function open(index) {
    show(index);
    lightbox.showModal();
    document.body.classList.add('product-gallery-open');
  }

  function close() {
    lightbox.close();
    document.body.classList.remove('product-gallery-open');
  }

  viewer.querySelectorAll('[data-gallery-open]').forEach(function (button) {
    button.addEventListener('click', function () { open(Number(button.dataset.galleryOpen || 0)); });
  });
  lightbox.querySelector('[data-gallery-close]')?.addEventListener('click', close);
  lightbox.querySelector('[data-gallery-previous]')?.addEventListener('click', function () { show(current - 1); });
  lightbox.querySelector('[data-gallery-next]')?.addEventListener('click', function () { show(current + 1); });
  lightbox.addEventListener('click', function (event) { if (event.target === lightbox) close(); });
  lightbox.addEventListener('close', function () { document.body.classList.remove('product-gallery-open'); });
  lightbox.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowLeft') show(current - 1);
    if (event.key === 'ArrowRight') show(current + 1);
  });
}

document.addEventListener('click', function (event) {
  var back = event.target.closest('[data-product-back]');
  if (!back) return;
  var referrer = document.referrer ? new URL(document.referrer) : null;
  if (referrer && referrer.origin === window.location.origin) {
    event.preventDefault();
    window.history.back();
  }
});

function initCatalogueDefaults(scope) {
  var toolbar = scope.querySelector('[data-default-sort]');
  if (!toolbar) return;
  var url = new URL(window.location.href);
  var sortValue = url.searchParams.get('sort_by') || toolbar.dataset.defaultSort || 'artist-ascending';
  var sortSelect = toolbar.querySelector('[name="sort_by"]');
  if (sortSelect && Array.from(sortSelect.options).some(function (option) { return option.value === sortValue; })) sortSelect.value = sortValue;
  applyCatalogueSort(scope, sortValue);
  var artistValue = url.searchParams.get('artist') || '';
  var artistSelect = toolbar.querySelector('[data-artist-filter]');
  if (artistSelect && Array.from(artistSelect.options).some(function (option) { return option.value === artistValue; })) artistSelect.value = artistValue;
  applyCatalogueArtistFilter(scope, artistValue);
}

function applyCatalogueArtistFilter(scope, artistValue) {
  var grid = scope.querySelector('[data-catalogue-grid]');
  if (!grid) return;
  var normalizedArtist = String(artistValue || '').toLocaleLowerCase('en');
  var visible = 0;
  grid.querySelectorAll('[data-product-card]').forEach(function (card) {
    var matches = !normalizedArtist || String(card.dataset.artist || '').toLocaleLowerCase('en') === normalizedArtist;
    card.hidden = !matches;
    if (matches) visible += 1;
  });
  var empty = scope.querySelector('[data-catalogue-filter-empty]');
  if (empty) empty.hidden = visible > 0;
}

function applyCatalogueSort(scope, sortValue) {
  var grid = scope.querySelector('[data-catalogue-grid]');
  if (!grid) return;
  var cards = Array.from(grid.querySelectorAll('[data-product-card]'));
  var parts = String(sortValue || 'artist-ascending').split('-');
  var direction = parts.pop() === 'descending' ? -1 : 1;
  var field = parts.join('-');
  cards.sort(function (a, b) {
    if (field === 'price') return ((Number(a.dataset.priceSort) || 0) - (Number(b.dataset.priceSort) || 0)) * direction;
    var key = field === 'title' ? 'titleSort' : 'artistSort';
    var result = String(a.dataset[key] || '').localeCompare(String(b.dataset[key] || ''), 'en', { sensitivity: 'base' });
    if (result === 0 && field === 'artist') result = String(a.dataset.titleSort || '').localeCompare(String(b.dataset.titleSort || ''), 'en', { sensitivity: 'base' });
    return result * direction;
  });
  cards.forEach(function (card) { grid.appendChild(card); });
}

function initInquiryContext(scope) {
  var params = new URLSearchParams(window.location.search);
  var title = params.get('title');
  var artwork = params.get('artwork');
  var subject = scope.querySelector('#ContactSubject');
  var inquiryType = scope.querySelector('input[name="contact[Inquiry type]"]');
  var routing = scope.querySelector('#ContactRouting');
  var reference = scope.querySelector('#ContactReference');
  var sourceUrl = scope.querySelector('#ContactSourceUrl');
  var context = scope.querySelector('[data-inquiry-context]');

  if (sourceUrl) sourceUrl.value = window.location.href;

  if (params.get('inquiry') === 'exhibition') {
    if (inquiryType) inquiryType.value = 'Exhibition invitation request';
    if (routing) routing.value = 'rsvp@totuartp2.com';
  } else if (params.get('inquiry') === 'artwork' || artwork) {
    if (inquiryType) inquiryType.value = 'Artwork inquiry';
    if (routing) routing.value = 'artworks@totuartp2.com';
  }

  if (title && subject) subject.value = title;
  if (reference) reference.value = artwork || title || '';
  if (context && (title || artwork)) {
    context.textContent = 'Inquiry: ' + (title || artwork.replace(/-/g, ' '));
    context.hidden = false;
  }
}

function initExhibitionStatuses(scope) {
  scope.querySelectorAll('[data-exhibition-status]').forEach(function (exhibition) {
    var label = exhibition.querySelector('[data-exhibition-status-label]');
    if (!label) return;
    var start = new Date(exhibition.dataset.startDate + 'T00:00:00');
    var end = new Date(exhibition.dataset.endDate + 'T23:59:59');
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return;
    var currentFrom = new Date(start);
    currentFrom.setDate(currentFrom.getDate() - Number(exhibition.dataset.currentLeadDays || 7));
    var now = new Date();
    if (now > end) label.textContent = label.dataset.pastLabel || 'Past exhibition';
    else if (now >= currentFrom) label.textContent = label.dataset.currentLabel || 'Current exhibition';
    else label.textContent = label.dataset.upcomingLabel || 'Upcoming exhibition';
  });
}

function initCarousels(scope) {
  scope.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    if (carousel.dataset.carouselReady === 'true') return;

    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-slide]'));
    if (!slides.length) return;

    carousel.dataset.carouselReady = 'true';
    var current = 0;
    var currentLabel = carousel.querySelector('[data-carousel-current]');
    var previousButton = carousel.querySelector('[data-carousel-prev]');
    var nextButton = carousel.querySelector('[data-carousel-next]');
    var timer = null;
    var delay = Number(carousel.dataset.carouselAutoplay || 0) * 1000;

    function showSlide(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (currentLabel) currentLabel.textContent = String(current + 1);
      var hero = carousel.closest('.hero');
      if (hero) {
        var tone = slides[current].dataset.heroTone || 'auto';
        hero.classList.remove('hero--tone-auto', 'hero--tone-dark', 'hero--tone-light');
        hero.classList.add('hero--tone-' + tone);
      }
    }

    function stopAutoplay() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function startAutoplay() {
      stopAutoplay();
      if (delay > 0 && slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(function () { showSlide(current + 1); }, delay);
      }
    }

    if (previousButton) previousButton.addEventListener('click', function () { showSlide(current - 1); startAutoplay(); });
    if (nextButton) nextButton.addEventListener('click', function () { showSlide(current + 1); startAutoplay(); });
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);

    showSlide(0);
    startAutoplay();
  });
}

document.addEventListener('shopify:section:load', function (event) {
  initCarousels(event.target);
  initExhibitionStatuses(event.target);
  initInquiryContext(event.target);
  initCatalogueDefaults(event.target);
  initProductGallery(event.target);
  initBaranskaCatalogue(event.target);
  initBookingWidgets(event.target);
});

function initBookingWidgets(scope) {
  scope.querySelectorAll('[data-booking-widget]').forEach(function (widget) {
    if (widget.dataset.bookingReady === 'true') return;
    widget.dataset.bookingReady = 'true';
    var endpoint = widget.dataset.bookingEndpoint;
    var form = widget.querySelector('[data-booking-form]');
    var dateSelect = widget.querySelector('[data-booking-date]');
    var slots = widget.querySelector('[data-booking-slots]');
    var status = widget.querySelector('[data-booking-status]');
    var submit = widget.querySelector('[data-booking-submit]');
    var dates = ['2026-12-01','2026-12-02','2026-12-03','2026-12-04','2026-12-05','2026-12-06'];
    var dateFormatter = new Intl.DateTimeFormat('en-US', { weekday: 'long', month: 'long', day: 'numeric', timeZone: 'America/New_York' });
    dates.forEach(function (date) {
      var option = document.createElement('option');
      option.value = date;
      option.textContent = dateFormatter.format(new Date(date + 'T12:00:00-05:00'));
      dateSelect.appendChild(option);
    });

    function renderSlots(availability) {
      slots.innerHTML = '';
      Object.keys(availability).forEach(function (time) {
        var remaining = availability[time];
        var label = document.createElement('label');
        label.className = 'booking-slot' + (remaining < 1 ? ' is-full' : '');
        label.innerHTML = '<input type="radio" name="visitTime" value="' + time + '" ' + (remaining < 1 ? 'disabled' : 'required') + '><span><strong>' + time + '</strong><small>' + (remaining < 1 ? 'Fully booked' : remaining + ' places left') + '</small></span>';
        slots.appendChild(label);
      });
    }

    function defaultAvailability() {
      var values = {};
      for (var hour = 14; hour <= 19; hour += 1) {
        ['00','30'].forEach(function (minute) {
          if (hour === 19 && minute === '30') return;
          var h = hour > 12 ? hour - 12 : hour;
          values[h + ':' + minute + ' PM'] = Number(widget.dataset.capacity || 20);
        });
      }
      return values;
    }

    dateSelect.addEventListener('change', async function () {
      if (!dateSelect.value) return;
      status.textContent = 'Checking availability…';
      try {
        if (!endpoint) throw new Error('preview');
        var response = await fetch(endpoint + '?action=availability&date=' + encodeURIComponent(dateSelect.value));
        var result = await response.json();
        renderSlots(result.availability);
        status.textContent = '';
      } catch (error) {
        renderSlots(defaultAvailability());
        status.textContent = endpoint ? 'Live availability could not be loaded. Please try again.' : 'Preview availability — reservations are not yet open.';
      }
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (!endpoint || !form.reportValidity()) return;
      submit.disabled = true;
      status.textContent = 'Confirming your reservation…';
      var payload = Object.fromEntries(new FormData(form).entries());
      payload.newsletterConsent = form.elements.newsletterConsent.checked;
      try {
        var response = await fetch(endpoint, { method: 'POST', body: JSON.stringify(payload), headers: { 'Content-Type': 'text/plain;charset=utf-8' } });
        var result = await response.json();
        if (!result.ok) throw new Error(result.message || 'Reservation could not be completed.');
        form.reset();
        slots.innerHTML = '<p class="booking-help">Choose a date to see available arrival times.</p>';
        status.textContent = 'Your reservation is confirmed. Please check your email for the details.';
      } catch (error) {
        status.textContent = error.message || 'Reservation could not be completed. Please try again.';
      } finally {
        submit.disabled = false;
      }
    });
  });
}

function initBaranskaCatalogue(scope) {
  scope.querySelectorAll('[data-baranska-catalog]').forEach(function (dialog) {
    var catalogueId = dialog.dataset.baranskaCatalog;
    var opener = scope.querySelector('[data-catalog-open="' + catalogueId + '"]');
    if (!opener || dialog.dataset.catalogReady === 'true') return;
    dialog.dataset.catalogReady = 'true';
    var slides = Array.from(dialog.querySelectorAll('[data-catalog-slide]'));
    var currentLabel = dialog.querySelector('[data-catalog-current]');
    var current = 0;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        slide.hidden = slideIndex !== current;
        if (slideIndex === current) {
          var image = slide.querySelector('[data-catalog-src]');
          if (image && !image.src) image.src = image.dataset.catalogSrc;
        }
      });
      if (currentLabel) currentLabel.textContent = current + 1;
    }

    opener.addEventListener('click', function () {
      show(0);
      dialog.showModal();
      document.body.classList.add('product-gallery-open');
    });
    dialog.querySelector('[data-catalog-close]')?.addEventListener('click', function () { dialog.close(); });
    dialog.querySelector('[data-catalog-previous]')?.addEventListener('click', function () { show(current - 1); });
    dialog.querySelector('[data-catalog-next]')?.addEventListener('click', function () { show(current + 1); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () { document.body.classList.remove('product-gallery-open'); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') show(current - 1);
      if (event.key === 'ArrowRight') show(current + 1);
    });
  });
}

document.addEventListener('DOMContentLoaded', function () { initBaranskaCatalogue(document); });
